<script setup lang="ts">
const store = useBigHeroBannerStore();

const props = defineProps<{
  index: number;
  forceActive?: boolean;
}>();

const ariaHidden = computed(() =>
  store.currentSlideIndex !== props.index ? "true" : "false",
);
</script>

<template>
  <div
    class="big-hero-banner-slide"
    :data-index="index"
    :aria-hidden="ariaHidden"
  >
    <slot />
  </div>
</template>

<style scoped lang="postcss">
.big-hero-banner-slide {
  @apply w-full flex items-center justify-center absolute top-0 left-0 right-0 bottom-0 bg-transparent;
  z-index: 0;
}
</style>
